import { render, staticRenderFns } from "./PopUpSimpleCompany.vue?vue&type=template&id=57dbed12&scoped=true&"
import script from "./PopUpSimpleCompany.vue?vue&type=script&lang=js&"
export * from "./PopUpSimpleCompany.vue?vue&type=script&lang=js&"
import style0 from "./PopUpSimpleCompany.vue?vue&type=style&index=0&id=57dbed12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dbed12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VRow})
